import React, { useState } from "react";
import {
  FaMobileAlt,
  FaMapMarkedAlt,
  FaCreditCard,
  FaShieldAlt,
} from "react-icons/fa";
import rider from "../../assets/img/rider.jpg";

const Rider = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    "How do I book a ride?",
    "Can I schedule a ride in advance?",
    "What payment methods are accepted?",
    "Is my trip safe and insured?",
    "How do I contact support or my driver?",
  ];

  const answers = [
    "Just open the app, enter your pickup and destination, choose your ride type, and tap Book a driver will be with you in minutes!",
    "Yes! Tap the clock icon after entering your destination to schedule a ride up to 30 days ahead.",
    "We accept all major credit/debit cards, mobile wallets (Apple Pay, Google Pay), and cash in most cities.",
    "Absolutely. Every ride is insured. Drivers are background-checked, vehicles inspected, and you can share your live trip with family.",
    "Tap 'Help' in the app for 24/7 support, or tap 'Contact Driver' once matched to call or chat directly.",
  ];

  return (
    <div
      className="rider-page"
      style={{
        backgroundColor: "#fffdf5",
        minHeight: "100vh",
        padding: "60px 20px",
      }}
    >
      <style jsx>{`
        .title {
          font-size: 48px;
          font-weight: 900;
          text-align: center;
          color: #000;
          margin-bottom: 20px;
        }
        .highlight {
          color: #098535;
          background-color: #fede33;
          padding: 6px 14px;
          border-radius: 10px;
          display: inline-block;
        }

        /* Clean, justified, friendly hero text */
        .hero-writeup {
          font-size: 22px;
          font-weight: 600;
          color: #222;
          max-width: 960px;
          margin: 0 auto 90px;
          line-height: 1.7;
          text-align: justify;
          text-justify: inter-word;
          padding: 0 20px;
        }
        .hero-writeup strong {
          color: #000;
          font-weight: 800;
        }
        .hero-writeup .glow {
          color: #fede33;
          font-weight: 900;
          font-size: 26px;
          text-shadow: 0 0 16px rgba(254, 222, 51, 0.6);
        }

        .benefits-card {
          background: white;
          border-radius: 28px;
          padding: 60px 50px;
          box-shadow: 0 15px 50px rgba(0, 0, 0, 0.09);
          max-width: 1200px;
          margin: 0 auto 100px;
          position: relative;
          overflow: hidden;
        }

        /* NEW: Beautiful full-block image styling */
        .rider-img-container {
          position: relative;
          width: 100%;
          height: 400px;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
          margin-bottom: 30px;
        }

        .rider-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          transition: transform 0.5s ease;
        }

        .rider-img:hover {
          transform: scale(1.05);
        }

        /* Image overlay for better text contrast */
        .img-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.1) 0%,
            rgba(0, 0, 0, 0.4) 100%
          );
        }

        /* Image caption */
        .img-caption {
          position: absolute;
          bottom: 30px;
          left: 30px;
          right: 30px;
          color: white;
          font-size: 24px;
          font-weight: 700;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
          line-height: 1.3;
        }

        .img-caption span {
          color: #fede33;
        }

        /* Alternative: If you want a full-width image section instead */
        .full-image-section {
          width: 100%;
          height: 500px;
          margin: 60px 0;
          border-radius: 0;
          position: relative;
          overflow: hidden;
        }

        .full-image-section .rider-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .full-image-section .img-overlay {
          background: linear-gradient(
            to right,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(0, 0, 0, 0.3) 50%,
            transparent 100%
          );
        }

        .full-image-section .img-caption {
          max-width: 600px;
          font-size: 32px;
          bottom: 60px;
          left: 60px;
        }

        /* Removed: .heart-shape, .rider-img (old circular style) */

        .benefit-item {
          display: flex;
          align-items: flex-start;
          gap: 26px;
          margin-bottom: 38px;
          position: relative;
          z-index: 1;
        }
        .icon-circle {
          width: 64px;
          height: 64px;
          background: #fede33;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #098535;
          font-size: 30px;
        }
        .benefit-title {
          font-size: 22px;
          font-weight: 700;
          color: #000;
          margin: 0 0 8px 0;
        }
        .benefit-desc {
          color: #444;
          line-height: 1.7;
          font-size: 17px;
          margin: 0;
        }

        .faq-title {
          font-size: 44px;
          font-weight: 900;
          text-align: center;
          color: #000;
          margin: 120px 0 60px;
        }
        .faq-item {
          background: white;
          border-radius: 16px;
          padding: 22px 26px;
          margin-bottom: 18px;
          box-shadow: 0 4px 22px rgba(0, 0, 0, 0.07);
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .faq-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 14px 35px rgba(0, 0, 0, 0.12);
        }
        .faq-question {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 600;
          color: #333;
        }
        .plus {
          width: 34px;
          height: 34px;
          background: #098535;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          font-weight: bold;
          transition: transform 0.3s ease;
        }
        .faq-item.open .plus {
          transform: rotate(45deg);
        }
        .faq-answer {
          margin-top: 18px;
          color: #555;
          line-height: 1.8;
          padding-left: 80px;
        }

        @media (max-width: 992px) {
          .title,
          .faq-title {
            font-size: 38px;
          }
          .hero-writeup {
            font-size: 19px;
            margin-bottom: 70px;
            padding: 0 15px;
          }
          .glow {
            font-size: 23px;
          }
          .benefits-card {
            padding: 45px 25px;
            text-align: center;
          }

          /* Responsive image styles */
          .rider-img-container {
            height: 300px;
            margin-bottom: 40px;
          }

          .img-caption {
            font-size: 20px;
            bottom: 20px;
            left: 20px;
            right: 20px;
          }

          .full-image-section {
            height: 350px;
          }

          .full-image-section .img-caption {
            font-size: 24px;
            bottom: 30px;
            left: 30px;
          }

          /* Removed old circular image responsive styles */

          .benefit-item {
            flex-direction: column;
            text-align: center;
          }
          .icon-circle {
            margin: 0 auto 20px;
          }
        }

        @media (max-width: 768px) {
          .faq-answer {
            padding-left: 20px;
          }
        }

        @media (max-width: 576px) {
          .hero-writeup {
            font-size: 18px;
          }
          .glow {
            font-size: 21px;
          }
          .rider-img-container {
            height: 250px;
            border-radius: 16px;
          }
          .full-image-section {
            height: 300px;
            margin: 40px 0;
          }
          .full-image-section .img-caption {
            font-size: 20px;
            bottom: 20px;
            left: 20px;
          }
        }
      `}</style>

      {/* Hero Title */}
      <h1 className="title">
        Ride with <span className="highlight">confidence</span>
      </h1>

      {/* Hero Write-up */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <p className="hero-writeup">
              Forget stressful taxi stands, surge pricing, or wondering when
              your ride will show up.
              <br />
              With CabandGo, you get{" "}
              <strong>fast, reliable, and affordable rides</strong> — exactly
              when and where you need them.
              <br />
              Tap once to book. Track your driver live. Arrive safely and
              relaxed.
              <br />
              <strong>
                Every ride feels like <span className="glow">home</span>.
              </strong>
            </p>
          </div>
        </div>
      </div>

      {/* OPTION 1: Image above benefits section */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="rider-img-container">
              <img
                src={rider}
                alt="Happy CabandGo Rider enjoying a comfortable ride"
                className="rider-img"
              />
              <div className="img-overlay"></div>
              <div className="img-caption">
                Experience the joy of stress-free travel with{" "}
                <span>CabandGo</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits-card">
        <div className="row">
          {/* Full width benefits without image */}
          <div className="col-lg-12">
            <div className="benefit-item">
              <div className="icon-circle">
                <FaMobileAlt />
              </div>
              <div>
                <h3 className="benefit-title">One-Tap Booking</h3>
                <p className="benefit-desc">
                  Book instantly or schedule rides ahead — up to 30 days in
                  advance
                </p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="icon-circle">
                <FaMapMarkedAlt />
              </div>
              <div>
                <h3 className="benefit-title">Live Tracking & Sharing</h3>
                <p className="benefit-desc">
                  See your driver approach in real-time and share your trip with
                  friends or family
                </p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="icon-circle">
                <FaCreditCard />
              </div>
              <div>
                <h3 className="benefit-title">No Surprises Pricing</h3>
                <p className="benefit-desc">
                  See your fare upfront. Pay seamlessly with card, wallet, or
                  cash
                </p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="icon-circle">
                <FaShieldAlt />
              </div>
              <div>
                <h3 className="benefit-title">Safety First, Always</h3>
                <p className="benefit-desc">
                  Verified drivers, insured rides, 24/7 support, and emergency
                  assistance
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* OPTION 2: Alternative - Full-width image section (uncomment if preferred) */}
      {/*
      <div className="full-image-section">
        <img src={rider} alt="Happy CabandGo Rider" className="rider-img" />
        <div className="img-overlay"></div>
        <div className="img-caption">
          Join thousands of happy riders who trust <span>CabandGo</span> for their daily commute
        </div>
      </div>
      */}

      {/* FAQ Section */}
      <h2 className="faq-title">
        Got questions? <span className="highlight">We've got you</span>
      </h2>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            {faqs.map((question, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? "open" : ""}`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="faq-question">
                  <span>{question}</span>
                  <div className="plus">+</div>
                </div>
                {openIndex === index && (
                  <div className="faq-answer">{answers[index]}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rider;
